import React, { Fragment, useEffect, useRef, useState } from "react";
import { getApi } from "../../services/api/globalApi";
import Pagination from "./../../components/common/pagination/Pagination";
import { useNavigate } from "react-router";
import { motion } from "framer-motion"
import AgentModal from "./AgentModal.jsx";
import Loadning from './../../components/common/loading/Loading.jsx'
import { FaUsers } from "react-icons/fa";

const AgentList = () => {

    const [data, setData] = useState([])
    const [pagination, setPagination] = useState()
    const [showDropDown, setShowDropDown] = useState(false)
    const [showLoading, setShowLoading] = useState(false)

    const getAgent = async (params) => {
        setData([])
        setShowLoading(true)
        const path = 'admin/users';
        try {
            const data = await getApi({ path, params: { ...params, limit: 8 } });
            console.log(data?.data)
            setPagination(data?.data.data)
            setData(data?.data.data.docs)
            setShowLoading(false)
        } catch (error) {
            console.log(error)
            setShowLoading(false)
        }
    }

    const [province, setProvince] = useState([])

    const getProvince = async () => {
        const params = { notPagination: 1, limit: 50 }
        try {
            const data = await getApi({ path: "admin/utils/provinces", params })
            console.log(data)
            setProvince(data?.data.data)

        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getAgent({ page: 1, archive: 0 })
        getProvince()
    }, [])

    const [searchType, setSearchType] = useState('name')

    const changeSearchType = (value) => {
        setSearchType(value)
        setShowDropDown(false)
        filterDataHandler({ page: 1, name: "", mobile: '' })
        document.getElementById('searchInput').value = '';
    }



    const [filter, setFilter] = useState();

    const filterDataHandler = (newParams) => {
        setFilter({ ...filter, ...newParams });
        const allFilter = {
            ...filter,
            ...newParams,
        };
        console.log("filter", allFilter);
        getAgent(allFilter);
    };


    const navigate = useNavigate()

    const editAgent = (item) => {
        navigate(`/agent/${item._id}`, { state: { data: item } });
    }

    const [agentData, setAgentData] = useState()

    const agentRef = useRef();

    const showModal = (item) => {
        setAgentData(item)
        agentRef.current.showModal()
    }

    const clearState = () => {
        setAgentData()
    }

    return (
        <Fragment>

            {showLoading && <Loadning />}

            <AgentModal ref={agentRef} agentData={agentData} filterDataHandler={filterDataHandler} clearState={clearState} />

            <motion.div
                initial={{ opacity: 0, scale: 0.5 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{
                    duration: 0.5,
                    // ease: [0, 0.71, 0.2, 1.01]
                }}
                className="w-11/12 mx-auto rounded-lg my-6 bg-white/50 backdrop-blur-sm dark:bg-[#060d26]/50 shadow-lg p-6">

                <h6 className="mb-6 mt-2 text-gray-800 dark:text-white flex gap-x-2 items-center">
                    <FaUsers size={26} />
                    لیست نمایندگان
                </h6>

                <div className="w-full flex flex-col flex-wrap my-8 gap-6 px-6">

                    <div className="w-full flex flex-col sm:flex-row gap-6">
                        <div
                            className="w-full sm:w-4/12">
                            <select onChange={(e) => filterDataHandler({ page: 1, province: e.target.value })} id="province" className="bg-white text-center sm:text-right border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                <option value={""} selected>همه ی استان ها</option>
                                {province?.map((item, index) => {
                                    return (
                                        <option key={index} value={item._id}>{item.name}</option>
                                    )
                                })}
                            </select>
                        </div>

                        <div
                            className="w-full sm:w-4/12">
                            <select onChange={(e) => filterDataHandler({ page: 1, status: e.target.value })} id="status" className="bg-white text-center sm:text-right border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                <option value={''}>تمامی نمایندگان</option>
                                <option value="active" selected>نمایندگان فعال</option>
                                <option value="inactive">نمایندگان غیر فعال</option>
                            </select>
                        </div>
                        <div
                            className="w-full sm:w-4/12">
                            <select onChange={(e) => filterDataHandler({ page: 1, archive: e.target.value })} id="status" className="bg-white text-center sm:text-right border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                <option value={0} selected>نمایندگان غیر آرشیو</option>
                                <option value={1}>نمایندگان آرشیو</option>
                            </select>
                        </div>
                    </div>

                    <div
                        initial={{ opacity: 0, scale: 0.5 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{
                            duration: 0.8,
                            delay: 0.5,
                            ease: [0, 0.71, 0.2, 1.01]
                        }}
                        className="w-full">
                        <div className="flex relative">
                            <label for="search-dropdown" className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white">.</label>
                            <button onClick={() => setShowDropDown(!showDropDown)}
                                id="dropdown-button"
                                className="flex-shrink-0 z-10 inline-flex items-center py-2.5 p-2 sm:px-4 text-sm font-medium text-center text-gray-900 bg-gray-100 border border-gray-300 rounded-s-lg hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:focus:ring-gray-700 dark:text-white dark:border-gray-600" type="button">
                                {searchType == 'name' ? "جستوجو نام" : 'جستوجو موبایل'}
                                <svg className="w-2.5 h-2.5 ms-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 4 4 4-4" />
                                </svg></button>

                            <div onClick={() => setShowDropDown(!showDropDown)} className={`fixed top-0 right-0 z-10 w-full h-full ${!showDropDown && 'hidden'}`}></div>

                            <div id="dropdown" className={`z-10 absolute bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700 transition-all ${showDropDown ? "mt-12 visible opacity-100" : "top-0 mt-4 invisible opacity-0"}`}>
                                <ul className="py-2 text-sm text-gray-700 dark:text-gray-200">
                                    <li>
                                        <button onClick={() => { changeSearchType('name') }} type="button" className="inline-flex justify-between w-full px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">بر اساس نام
                                            {searchType == 'name' && <img className="w-4 h-4" src={require('./../../assets/images/tick-icon.png')} alt="" />}
                                        </button>
                                    </li>
                                    <li>
                                        <button onClick={() => { changeSearchType('mobile') }} type="button" className="inline-flex justify-between w-full px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">بر اساس شماره
                                            {searchType == 'mobile' && <img className="w-4 h-4" src={require('./../../assets/images/tick-icon.png')} alt="" />}
                                        </button>
                                    </li>
                                </ul>
                            </div>

                            <div className="relative w-full">
                                <input id="searchInput" onChange={(e) => filterDataHandler({ page: 1, [`${searchType}`]: e.target.value })} type="search" className="block p-2.5 w-full z-20 text-sm text-gray-900 bg-white rounded-e-lg border-s-gray-50 border-s-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-s-gray-700  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-blue-500" placeholder="جستوجو" required />
                                <button type="submit" className="absolute top-0 end-0 p-2.5 text-sm font-medium h-full text-white bg-blue-700 rounded-e-lg border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                    <svg className="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                                    </svg>
                                    <span className="sr-only">جستوجو</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>


                {data?.length > 0 ? <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                    <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                        <thead className="text-xs text-gray-700 uppercase bg-gray-200 dark:bg-gray-700 dark:text-gray-400">
                            <tr>
                                <th scope="col" className="px-6 py-3">
                                    نام
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    شماره
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    استان
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    وضعیت
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    آرشیو
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    <span className="sr-only">ویرایش</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {data ? data?.map((item, index) => {
                                return (
                                    <tr key={index} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                        <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                            {item.name || "-"}
                                        </th>
                                        <td className="px-6 py-4">
                                            {item.mobile || "-"}
                                        </td>
                                        <td className="px-6 py-4">
                                            {item.province.name || "-"}
                                        </td>
                                        <td className="px-6 py-4">
                                            {item?.status == 'active' ? <span className="flex items-center gap-x-2">فعال
                                                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" class="text-green-500" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"></path></svg>
                                            </span> : item?.status == 'unActive' ? <span className="flex items-center gap-x-2">
                                                غیر فعال
                                                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" class="text-red-500" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"></path></svg>
                                            </span> :
                                                <span className="flex items-center gap-x-2">
                                                    در حال بررسی
                                                    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" class="text-orange-500" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"></path></svg>
                                                </span>
                                            }
                                        </td>
                                        <td className="px-6 py-4">
                                            {item?.archive == true ? "بله" : "خیر"}
                                        </td>
                                        <td className="px-6 py-4 text-right flex">
                                            <p onClick={() => editAgent(item)} className="font-medium cursor-pointer text-blue-600 mx-3 dark:text-blue-500 hover:underline">ویرایش</p>
                                            {item?.archive == false && <p onClick={() => showModal(item)} className="font-medium cursor-pointer text-red-600 dark:text-blue-500 hover:underline">آرشیو</p>}
                                        </td>
                                    </tr>
                                )
                            }) : null}

                        </tbody>
                    </table>
                </div>
                    :
                    <p className="w-full py-2 flex justify-center items-center text-gray-800 dark:text-white">شما هنوز هیچ کاربری ثبت نکرده اید</p>
                }
                <div className="mt-6">
                    <Pagination pagination={pagination} filterDataHandler={filterDataHandler} />
                </div>

            </motion.div>
        </Fragment>
    )
}

export default AgentList